module Meevo.Components.BaseClasses {
    "use strict";

    /**
    * Service Commissions Section of Employee
    */
    export class ServiceCommissionsSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Employee> {
        COLOR_STANDARD: string = "white";
       

        defaultCriteria() {
            let criteria = {
                doesNotPerform: 0,
                includeActive: true 
            };
            return criteria;
        }

        getAmountBackgroundColor(compensation: any, servCommType: number): any {
            return this.COLOR_STANDARD;
        }

        getCompensationRate(compensation: any, servCommType: number): any {
            let compensationRate: any;

            switch (servCommType) {
            case Meevo.Model.ServiceCommissionAdjustmentTypeEnum.ShopCosts:
                compensationRate = compensation.shopCostCommissionRate;
                break;
            case Meevo.Model.ServiceCommissionAdjustmentTypeEnum.LaborCosts:
                compensationRate = compensation.laborCostCommissionRate;
                break;
            case Meevo.Model.ServiceCommissionAdjustmentTypeEnum.NewClientDeductions:
                compensationRate = compensation.newClientDeductionRate;
                break;
            case Meevo.Model.ServiceCommissionAdjustmentTypeEnum.Commission:
                compensationRate = compensation.overrideStandardServiceRate;
                break;
            }
            return compensationRate;
        }
     }
}